import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgFolderLibrary = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.068 13.71h17.737M18.137 13.69c-.374-.415-.879-.796-1.497-1.153l-4.572-2.64c-2.097-1.21-4.048-.686-5.262 1.417l-1.316 2.28"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.64 20.987c3.357 0 5.334-1.979 5.334-5.333L21 10.998c0-3.423-1.242-5.135-4.605-5.135h-2.653a2.15 2.15 0 0 1-1.712-.856l-.856-1.138a2.14 2.14 0 0 0-1.711-.856H7.588C4.232 3.013 3 4.99 3 8.34v7.313c0 3.354 1.981 5.333 5.345 5.333z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgFolderLibrary);
export default ForwardRef;
